import { useSelector } from 'react-redux'
import { getUUID } from '../../../../../../utility'
import Default from './Item/Default'
import props from '../../../../../../redux/props'
import { NavigationItem } from '../../types'

type Props = {
  mobile?: boolean
  onClick?: () => void
}

const Items: React.FC<Props> = ({ mobile = false, onClick = null }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <>
      {t.header.navigation.default.map((item: NavigationItem) => (
        <Default mobile={mobile} onClick={onClick} key={getUUID()} data={item} />
      ))}
    </>
  )
}

export default Items
